import { render, staticRenderFns } from "./ErcpViewComponent.vue?vue&type=template&id=72565699"
import script from "./ErcpViewComponent.vue?vue&type=script&lang=js"
export * from "./ErcpViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports